import logo from '@/res/images/logo-bw.png';
import packageJson from '../../../package.json';
import { Box, Center, Container, Flex, Group, Overlay, Stack, Text } from '@mantine/core';
import { Cube } from './Cube';
import { accent } from '@/res/costants/colors';

export const Splash = () => {
  return (
    <Box bg={accent} h="100%" px="xl">
      <Container size="xs" h="100%">
        <Center h="100%" w="100%">
          <Stack justify="space-between" align="center" gap="xl">
            <Group align="start">
              <img height={56} src={logo} alt="logo" />
              <Text size="md" c="gray.1">
                {packageJson.version}
              </Text>
            </Group>
            <Cube />
          </Stack>
        </Center>
      </Container>
    </Box>
  );
};

export default Splash;
